import type {
  GetResolverLinkPathProps,
  MatchResolverLinkRouteProps,
} from "./router-resolver-gate.type";

import { generatePath, matchPath } from "react-router";

import { QUERY_PLACEHOLDER_REGEX } from "./router-resolver-gate.constant";

export const getResolverLinkPath = ({
  routes,
  pathname,
  search,
}: GetResolverLinkPathProps): string | undefined => {
  for (const route of routes) {
    const redirectPath = matchResolverLinkRoute({
      route,
      pathname,
      search,
    });
    if (redirectPath) return redirectPath;
  }

  return undefined;
};

const matchResolverLinkRoute = ({
  route,
  pathname,
  search,
}: MatchResolverLinkRouteProps): string | undefined => {
  const match = matchPath({ path: route.from, end: true }, pathname); // exact match only

  if (!match) return undefined;

  const sourceSearchParams = new URLSearchParams(search);
  const context = sourceSearchParams.get("context") ?? undefined;

  if (route.to.includes(":context") && !context) return undefined;

  const params: Record<string, string | undefined> = {
    ...Object.fromEntries(sourceSearchParams.entries()),
    ...match.params,
    context: context,
  };

  const [targetPathPattern, targetSearchPattern] = route.to.split("?");

  let targetPath = "";

  try {
    targetPath = generatePath(targetPathPattern, params);
  } catch {
    return undefined;
  }

  if (!targetSearchPattern) return targetPath;

  const targetSearch = targetSearchPattern.replace(
    QUERY_PLACEHOLDER_REGEX,
    (_full, key: string) => params[key] ?? `:${key}`
  );

  if (QUERY_PLACEHOLDER_REGEX.test(targetSearch)) return undefined;

  return `${targetPath}?${targetSearch}`;
};
